// Copyright 2024 - MinIO, Inc. All rights reserved.

import { Api } from "./catalogApi";

export let rootCatApi = new Api();
